export enum Status {
    WON = 'Won',
    LOST = 'Lost',
    DEAL = 'Deal',
  }
  export enum typeGroup {
    SMS = 'Sms',
    EMAIL = 'Email',
    NOTE = 'Note',
    REASSIGN = 'Reassign',
    CHANGE_STEP = 'CHANGE_STEP'  // NEW
  }

  export enum StepperMenu {
    STEPPER = 'Stepper',
    CONDITION = 'Condition',
    TRIGGER = 'Trigger',
    ACTION = 'Action',
    SMS_TEMPLATE = 'Sms Template',
    EMAIL_TEMPLATE ='Email template',
    WAIT_CONDITION = 'WAIT CONDITION',
    ADD_NOTE = 'add note',
    UPDATE_LEAD = 'update lead',
    ADD_NOTIFICATION = 'add notification',
    ADD_CAMPAIGN = 'add campaign',
    DELAY='DELAY',
    ACTIVITY_ACTION= 'Create Activity',
    ACTIVITY_UPDATE= 'update activity',
    DELAY_STEP= 'Delay Step',
  }